import { CatalogNavigationModel } from '@marketplace-web/domain/catalog-data'

import { BannersModel } from '../types/banners'
import {
  findListerActivationBannerFromCatalogIds,
  getParentListerActivationBanner,
  getRootCatalogListerActivationBanners,
} from '../utils/lister-activation-banner'

type Props = {
  banners: BannersModel
  selectedCatalogIds: Array<number>
  catalogs: Array<CatalogNavigationModel>
}

const useListerActivationBanner = ({ banners, selectedCatalogIds, catalogs }: Props) => {
  const { listerActivation } = banners

  if (!listerActivation.length) return []

  const selectedCatalogs = catalogs.filter(catalog => selectedCatalogIds.includes(catalog.id))

  if (!selectedCatalogs.length) return listerActivation

  const directBanner = findListerActivationBannerFromCatalogIds(
    selectedCatalogIds,
    listerActivation,
  )
  const targetBanner = directBanner ? [directBanner] : undefined
  const catalogMap = catalogs.reduce((acc: Record<number, CatalogNavigationModel>, catalog) => {
    return { ...acc, [catalog.id]: catalog }
  }, {})

  return (
    targetBanner ||
    getParentListerActivationBanner(selectedCatalogs, catalogMap, listerActivation) ||
    getRootCatalogListerActivationBanners(selectedCatalogs, listerActivation) ||
    listerActivation
  )
}

export default useListerActivationBanner
